import { GREETING_LANDING_INFO } from '/state/actions/greeting_landing'

const initialState = {
    id: null,
    color: null,
    tag: null,
    name: null,
    emblem: null,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case GREETING_LANDING_INFO: {
        const { id, color, tag, name, emblem } = action.payload
        return { ...state, id, color, tag, name, emblem }
    }

    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/greeting_landing.js